import { getGraphToken } from './AuthProvider'; // ✅ not getWebApiToken
import { graphConfig } from './msalConfig';

export const getProfile = async () => {
  const token = await getGraphToken(); // ✅ Graph token
  if (!token) return null;

  const headers = new Headers();
  headers.append('Authorization', `Bearer ${token}`);

  return fetch(graphConfig.graphMeEndpoint + '/photo/$value', {
    method: 'GET',
    headers: headers,
  }).then((response) => {
    if (!response.ok) throw new Error(`Graph error: ${response.status}`);
    return response.blob();
  });
};
